import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class configTagsView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="w-form w-form-large view-tag">
                
                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn no-bg icon i-back" type="button">Go Back</button> 
                        <h3 class="form-title" data-bind="text: name"></h3>
                        <div>
                            <button data-bind="event: { click: onClickEdit }" class="btn emp icon i-edit" type="button">Edit Tag</button> 
                        </div>
                    </div>
                    
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Name</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: name"></span>
                                    </dd>
                                    <dt>
                                        <span>Slug</span>
                                    </dt>
                                    <dd class="no-cap">
                                        <span data-bind="text: slug"></span>
                                    </dd>
                                   
                                    <dt>
                                        <span>Selectable Status</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: isSelectable"></span>
                                    </dd> 
                                    <dt>
                                        <span>Date Created</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: dateCreated"></span>
                                    </dd> 
                                </dl>
                            </div>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <dl class="double-list">
                                
                                    <dt class="full-width">
                                        <span>Type</span>
                                    </dt>
                                    <dd class="no-cap full-width">
                                        <span>Type</span>
                                    </dd>
                                   
                                    <dt class="full-width">
                                        <span>Description</span>
                                    </dt>
                                    <dd class="full-width no-cap">
                                        <span data-bind="text: description"></span>
                                    </dd>
           
                                 </dl>
                            </div>
                            <div class="form-group">
                                <div class="form-group img"> 
                                    <div class="w-img" id="tagImage">
                                        <img src="https://static1.moviewebimages.com/wordpress/wp-content/uploads/article/c74wusuBmnafbrX1VdDA3gnHzh0KDs.jpg" alt="image not found" />
                                        <button class="btn-form icon i-close" type="button" ><span>close</span></button>                                
                                    </div>
                                    <button class="btn-form icon i-view"><span>view</span></button>
                                    <button class="btn-form icon i-edit"><span>edit</span></button>
                                    <button class="btn-form icon i-image"><span>Select Image</span></button>
                                </div>    
                            </div>
                        </div>
                     </div>
                     <div class="w-form-body">
                        <strong class="form-sub-title">Specifications</strong>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <table class="list-action full-width">
                                    <thead>
                                        <tr style="background-color: #8a8a8a">
                                            <th>
                                                <span>Field Name</span>
                                            </th>
                                             <th>
                                                <span>Type</span>
                                            </th>
                                            <th>
                                                <span>Value</span>
                                            </th>
                                            <th style="width: 10rem;">
                                                <span>Forced Overwrite</span>
                                            </th>
          
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span>Brand</span>
                                            </td>
                                            <td>
                                                <span>Text</span>
                                            </td>
                                            <td>
                                                <span>Date</span>
                                            </td>
                                            <td>
                                                <div class="align-center">
                                                    <span class="check icon i-check" ></span>
                                                </div>     
                                            </td>
              
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                `;
    }

    protected initPartial(): void{

    }

    protected getTemplateName(): string{

        return "configTagsView_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            id: ko.observable("")
            , name: ko.observable("")
            , slug: ko.observable("")
            , description: ko.observable("")
            , isSelectable: ko.observable("")
            , dateCreated: ko.observable("")
            , onClickEdit: function (data,  event){
                huit_neuf_this.onClickEdit(data.id());
            }
            , onClickCancel: function (data, event){
                huit_neuf_this.onClickCancel();
            }
        }
    };

    public onClickEdit(id){

        this.caller.edit(id);
    }

    public onClickCancel(){

        this.caller.cancel();
    }


    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setName(name): void{

        this.getTemplateViewModel().name(name);
    }

    public setSlug(name): void{

        this.getTemplateViewModel().slug(name);
    }

    public setDescription(description): void{

        this.getTemplateViewModel().description(description);
    }

    public setIsSelectable(isSelectable): void{

        this.getTemplateViewModel().isSelectable(isSelectable);
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(dateCreated);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/configTagsView_template.ts